/**
 * @file: 文本框操作
 * @author: xiaolong.huang@dmall.com
 */

import { create } from './create';

export default {
    create
}
